import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from 'src/app/services/core/api/services';
import { ToastService } from 'src/app/services/toast-service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { LoadingSpinnerService } from 'src/app/shared/loading-spinner.service';

@Component({
  selector: 'cs-forgot-password',
  templateUrl: 'forgot-password.page.html',
  styleUrls: ['forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {
  data: any = {
    "background"          : "assets/imgs/background/Login_wide.jpg",
  };

  private isEmailValid = true;
  private isLoading = false;
  private success = '';

  private regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  item = {
    'email': ''
  };

  constructor(
    private loginService: LoginService,
    private toastCtrl: ToastService,
    private loadingService: LoadingSpinnerService,
    private router: Router,
    private authService: AuthService,
    private translationService: TranslateService
  ) { }

  ngOnInit(): void {
    this.loadingService.isLoading.subscribe(loading => {
      this.isLoading = loading;
    });
  }

  displayConfirm() {
    this.router.navigate(['forgot-password-confirm']);
  }

  onRegisterFunc(): void {
    if (event) {
      event.stopPropagation();
    }
    if (this.validate()) {
      const params = {
        body: {
          email: this.item.email.replace(' ', '')
        }
      }
      this.loginService.doResetPasswordPost(params).subscribe(s => {
        this.success = s.error;
        if (s.error === 'ERR') {
          this.toastCtrl.presentToast(s.error_description, 'danger');
        } else {
          // this.displayConfirm();
        }
      });
    }
  }

  validate(): boolean {
    this.isEmailValid = true;

    this.isEmailValid = this.regex.test(this.item.email);

    return this.isEmailValid
  }
}
